import { CheckoutCouponValidationRule } from '../interfaces/checkout-coupon-validation.interface';

export const checkoutCouponDiscountRule: CheckoutCouponValidationRule = context => ({
	...context,
	couponDiscount: (context.validation.items ?? []).reduce(
		(discount, item) => discount + BigInt(item.valorCalculado ?? 0n),
		0n
	),
});

export const checkoutCouponApplicabilityRule: CheckoutCouponValidationRule = context => {
	const cartSubtotal = context.cartSubtotal ?? 0n;

	return {
		...context,
		isApplicable: !(context.couponDiscount > cartSubtotal && cartSubtotal > 0n),
	};
};

export const checkoutCouponValidatedValueRule: CheckoutCouponValidationRule = context => ({
	...context,
	validatedCoupon: {
		...context.coupon,
		idCupon: context.validation.idCupon,
		nombre: context.validation.nombre,
		tipo: context.validation.tipo,
		valor: Number(context.validation.valor),
		esPorcentual: context.validation.esPorcentual,
		items: context.validation.items,
	},
});

export const checkoutCouponValidatedResultRule: CheckoutCouponValidationRule = context => {
	if (!context.validatedCoupon) {
		throw new Error('Coupon validation rules did not produce a validated coupon.');
	}

	return context;
};
